import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { useRealtime } from '@/lib/ws/useRealtime'
import { financeKeys } from './api'

type VoidEventData = { status?: string; summary?: string; approval_level?: string }

// Router bu bileşenin dışında kurulur; doğrudan import döngüsel bağımlılık yaratacağı için tıklamada yüklenir.
const openApprovals = () => void import('@/app/router').then((m) => m.router.navigate('/finance/approvals'))
const openPaymentRequests = () =>
  void import('@/app/router').then((m) => m.router.navigate('/finance/payment-requests'))

/**
 * Finans olaylarında ekranları tazeler. İptal talepleri: onaycıya yeni talep, talep edene karar
 * anında bildirilir; başka bir onaycının kararı (finance.void.changed) yalnız listeyi günceller.
 */
export function FinanceRealtime() {
  const qc = useQueryClient()
  const { t } = useTranslation()
  useRealtime(
    (event) =>
      event.startsWith('finance.expense') || event.startsWith('finance.void') || event.startsWith('finance.payment'),
    (msg) => {
      void qc.invalidateQueries({ queryKey: financeKeys.all })
      const data = (msg.data ?? {}) as VoidEventData
      if (msg.event === 'finance.payment.requested') {
        toast.info(t('finance.paymentRequests.live.requested'), {
          description: data.summary,
          action: { label: t('finance.paymentRequests.live.open'), onClick: openPaymentRequests },
        })
      } else if (msg.event === 'finance.payment.decided') {
        const status = data.status === 'approved' || data.status === 'rejected' || data.status === 'failed' ? data.status : 'updated'
        const show = status === 'approved' ? toast.success : status === 'updated' ? toast.info : toast.error
        show(t(`finance.paymentRequests.live.decided.${status}`), {
          description: data.summary,
          action: { label: t('finance.paymentRequests.live.open'), onClick: openPaymentRequests },
        })
      } else if (msg.event === 'finance.void.requested') {
        toast.info(t(data.approval_level === 'owner' ? 'finance.voids.live.requestedOwner' : 'finance.voids.live.requested'), {
          description: data.summary,
          action: { label: t('finance.voids.live.open'), onClick: openApprovals },
        })
      } else if (msg.event === 'finance.void.decided') {
        const status = data.status === 'approved' || data.status === 'rejected' || data.status === 'failed' ? data.status : 'updated'
        const show = status === 'approved' ? toast.success : status === 'updated' ? toast.info : toast.error
        show(t(`finance.voids.live.decided.${status}`), {
          description: data.summary,
          action: { label: t('finance.voids.live.open'), onClick: openApprovals },
        })
      }
    },
  )
  return null
}
